import { createContext } from "react";
import { ResultsContextDefaultData } from "./ResultsContextDefaultData";

export const ResultsContext = createContext(ResultsContextDefaultData);
